(() => {
  const root = document.querySelector('.fab-home');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('fab-motion-ready');

  const groups = [
    '.fab-heading', '.fab-sachet-copy', '.fab-app-copy', '.fab-proof-intro',
    '.fab-product-card', '.fab-loop-card', '.fab-eco-card', '.fab-app-feature-grid article',
    '.fab-proof-grid article', '.fab-faq details', '.fab-app-feature-lead', '.fab-finder-shell'
  ];
  const elements = [...root.querySelectorAll(groups.join(','))];
  elements.forEach((element, index) => {
    element.classList.add('fab-reveal');
    element.dataset.fabDelay = String((index % 3) + 1);
  });

  const animateCounter = (element) => {
    if (element.dataset.counted === 'true') return;
    const match = element.textContent.trim().match(/^(\d+)(.*)$/);
    if (!match) return;
    element.dataset.counted = 'true';
    const target = Number(match[1]);
    const suffix = match[2];
    const started = performance.now();
    const duration = 850;
    const tick = (now) => {
      const progress = Math.min((now - started) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = `${Math.round(target * eased)}${suffix}`;
      if (progress < 1) requestAnimationFrame(tick);
      else element.classList.add('fab-counter-pop');
    };
    requestAnimationFrame(tick);
  };

  if (reduceMotion || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.classList.contains('fab-performance-loop')) entry.target.classList.add('is-motion-active');
        entry.target.querySelectorAll?.('.fab-proof strong').forEach(animateCounter);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    elements.forEach((element) => observer.observe(element));
    const loop = root.querySelector('.fab-performance-loop');
    if (loop) observer.observe(loop);
    const heroProof = root.querySelector('.fab-hero .fab-proof');
    if (heroProof) {
      const counterObserver = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
          heroProof.querySelectorAll('strong').forEach(animateCounter);
          counterObserver.disconnect();
        }
      }, { threshold: 0.5 });
      counterObserver.observe(heroProof);
    }
  }

  if (!reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    root.querySelectorAll('.fab-product-card').forEach((card) => {
      card.classList.add('fab-tilt');
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        card.style.setProperty('--tilt-x', `${(0.5 - y) * 5}deg`);
        card.style.setProperty('--tilt-y', `${(x - 0.5) * 6}deg`);
        card.style.setProperty('--shine-x', `${x * 100}%`);
        card.style.setProperty('--shine-y', `${y * 100}%`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.removeProperty('--tilt-x'); card.style.removeProperty('--tilt-y');
      });
    });
  }
})();
